import RolesPageView from "./RolesPageView";

function RolesPage() {
  return <RolesPageView />;
}

export default RolesPage;
